import React from 'react';
import strings from "../../../localization";
import { getError, hasError } from "../../../functions/Validation";
import { Button, TextField, FormLabel, FormGroup, FormControlLabel, Checkbox, Radio, FormControl, RadioGroup } from "@material-ui/core";
import DatePickerControl from '../../controls/DatePickerControl';
import Autocomplete from '@material-ui/lab/Autocomplete';

const DeceasedMainBookOfCrematedForm = ({
  onSubmit,
  onCancel,
  onChange,
  errors,
  data,
  isDisabled,
  handleChange,
  onAutocompleteChange,
  handleTextInputChange,
  transporters,
  municipalities,
  states,
  occupations,
  causesOfDeath,
  doctors,
  famousCitizens,
  flag,
  dateFlag,
  dateOfBirthWhenValidIDNumber,
  onChangePersonalNumberField,
  date
}) => {
  return (

    <form id='user-form'>
      <TextField
        label={strings.mainBookOfCremated.form.mainBookOfCremated + "*"}
        error={hasError(errors, 'mainBookOfCremated')}
        helperText={getError(errors, 'mainBookOfCremated')}
        fullWidth
        autoFocus
        name='mainBookOfCremated'
        onChange={onChange}
        margin="normal"
        defaultValue={date}
        value={data.mainBookOfCremated}
        InputLabelProps={{
          shrink: true,
        }}
        disabled={isDisabled}
      />
      <TextField
        label={strings.mainBookOfCremated.form.identificationNumber + "*"}
        error={hasError(errors, 'identificationNumber')}
        helperText={getError(errors, 'identificationNumber')}
        fullWidth
        name='identificationNumber'
        onChange={onChangePersonalNumberField}
        margin="normal"
        defaultValue={data.identificationNumber}
        value={data.identificationNumber}
        InputLabelProps={{
          shrink: true,
        }}
        disabled={isDisabled}
      />
      <TextField
        label={strings.mainBookOfCremated.form.deceasedNameSurname + "*"}
        error={hasError(errors, 'deceasedNameSurname')}
        helperText={getError(errors, 'deceasedNameSurname')}
        fullWidth
        name='deceasedNameSurname'
        onChange={onChange}
        margin="normal"
        defaultValue={data.deceasedNameSurname}
        value={data.deceasedNameSurname}
        InputLabelProps={{
          shrink: true,
        }}
        disabled={isDisabled}
      />
      <FormControl component="fieldset">
        <FormLabel className="checkboxLabel"> {strings.mainBookOfCremated.form.gender} </FormLabel>
        <RadioGroup name="gender" value={(data.gender == true || data.gender == "true") ? "true" : "false"} onChange={handleChange} className="radioGroup">
          <FormControlLabel value={"true"} disabled={isDisabled} control={<Radio />} label={<span className="formControlLabel">{strings.mainBookOfCremated.form.male}</span>} />
          <FormControlLabel value={"false"} disabled={isDisabled} control={<Radio />} label={<span className="formControlLabel">{strings.mainBookOfCremated.form.female}</span>} />
        </RadioGroup>
      </FormControl>
      <TextField
        label={strings.mainBookOfCremated.form.fathersName}
        error={hasError(errors, 'fathersName')}
        helperText={getError(errors, 'fathersName')}
        fullWidth
        name='fathersName'
        onChange={onChange}
        margin="normal"
        defaultValue={data.fathersName}
        value={data.fathersName}
        InputLabelProps={{
          shrink: true,
        }}
        disabled={isDisabled}
      />
        {((data.state && flag == "edit") || (flag == "add") || (data.state && flag == "view")) &&
        <Autocomplete
          id={"state"}
          name={"state"}
          options={states}
          getOptionLabel={option => option.name}
          onChange={onAutocompleteChange}
          renderInput={params => (
            <TextField
              {...params}
              variant="standard"
              label={strings.mainBookOfCremated.form.republic}
              margin="normal"
              fullWidth
              name={"state"}
              onChange={handleTextInputChange}
              InputLabelProps={{
                shrink: true,
              }}
            />
          )}
          disabled={isDisabled}
          value={data.state}
        />
      }
      {((!data.state && flag == "edit") || (!data.state && flag == "view")) &&
        <Autocomplete
          id={"state"}
          name={"state"}
          options={states}
          getOptionLabel={option => option.name}
          onChange={onAutocompleteChange}
          renderInput={params => (
            <TextField
              {...params}
              variant="standard"
              label={strings.mainBookOfCremated.form.republic}
              margin="normal"
              fullWidth
              name={"state"}
              onChange={handleTextInputChange}
              InputLabelProps={{
                shrink: true,
              }}
            />
          )}
          disabled={isDisabled}
          value={data.state}
        />
      }
      {((data.municipality && flag == "edit") || (flag == "add") || (data.municipality && flag == "view")) &&
        <Autocomplete
          id={"municipality"}
          name={"municipality"}
          options={municipalities}
          getOptionLabel={option => `${option.city} ${option.zip}`}
          onChange={onAutocompleteChange}
          renderInput={params => (
            <TextField
              {...params}
              variant="standard"
              label={strings.mainBookOfCremated.form.municipality}
              margin="normal"
              fullWidth
              name={"municipality"}
              onChange={handleTextInputChange}
              InputLabelProps={{
                shrink: true,
              }}
            />
          )}
          disabled={isDisabled}
          value={data.municipality}
        />
      }
      {((!data.municipality && flag == "edit") || (!data.municipality && flag == "view")) &&
        <Autocomplete
          id={"municipality"}
          name={"municipality"}
          options={municipalities}
          getOptionLabel={option => `${option.city} ${option.zip}`}
          onChange={onAutocompleteChange}
          renderInput={params => (
            <TextField
              {...params}
              variant="standard"
              label={strings.mainBookOfCremated.form.municipality}
              margin="normal"
              fullWidth
              name={"municipality"}
              onChange={handleTextInputChange}
              InputLabelProps={{
                shrink: true,
              }}
            />
          )}
          disabled={isDisabled}
          value={data.municipality}
        />
      }
     <TextField
        label={strings.mainBookOfCremated.form.address}
        error={hasError(errors, 'address')}
        helperText={getError(errors, 'address')}
        fullWidth
        name='address'
        onChange={onChange}
        margin="normal"
        defaultValue={data.address}
        value={data.address}
        InputLabelProps={{
          shrink: true,
        }}
        disabled={isDisabled}
      />
      {((data.occupation && flag == "edit") || (flag == "add") || (data.occupation && flag == "view")) &&
        <Autocomplete
          id={"occupation"}
          name={"occupation"}
          options={occupations}
          getOptionLabel={option => option.name}
          onChange={onAutocompleteChange}
          renderInput={params => (
            <TextField
              {...params}
              variant="standard"
              label={strings.mainBookOfCremated.form.occupation}
              margin="normal"
              fullWidth
              name={"occupation"}
              onChange={handleTextInputChange}
              InputLabelProps={{
                shrink: true,
              }}
            />
          )}
          disabled={isDisabled}
          value={data.occupation}
        />
      }
      {((!data.occupation && flag == "edit") || (!data.occupation && flag == "view")) &&
        <Autocomplete
          id={"occupation"}
          name={"occupation"}
          options={occupations}
          getOptionLabel={option => option.name}
          onChange={onAutocompleteChange}
          renderInput={params => (
            <TextField
              {...params}
              variant="standard"
              label={strings.mainBookOfCremated.form.occupation}
              margin="normal"
              fullWidth
              name={"occupation"}
              onChange={handleTextInputChange}
              InputLabelProps={{
                shrink: true,
              }}
            />
          )}
          disabled={isDisabled}
          value={data.occupation}
        />
      }
      {(data.dateOfBirthString != undefined && data.dateOfBirthString != null && data.dateOfBirthString != "") &&
        <TextField
          label={strings.mainBookOfBuried.form.dateOfBirthString}
          fullWidth
          name='dateOfBirthString'
          onChange={handleTextInputChange}
          margin="normal"
          value={data.dateOfBirthString}
          InputLabelProps={{
            shrink: true,
          }}
          disabled={true}
        />
      }
      {dateFlag == "validIDNumber" &&
        <DatePickerControl
          label={strings.mainBookOfCremated.form.dateOfBirth}
          error={getError(errors, 'dateOfBirth')}
          hasError={hasError(errors, 'dateOfBirth')}
          helperText={getError(errors, 'dateOfBirth')}
          placeholder={strings.mainBookOfCremated.form.dateOfBirth}
          name='dateOfBirth'
          onChange={onChange}
          date={new Date(dateOfBirthWhenValidIDNumber[2] + "-" + dateOfBirthWhenValidIDNumber[1] + "-" + dateOfBirthWhenValidIDNumber[0])}
          isClearable={true}
          dateFormat='dd/MM/yyyy'
          disabled={isDisabled}
        />
      }

      {dateFlag == "invalidIDNumber" &&
        <DatePickerControl
          label={strings.mainBookOfCremated.form.dateOfBirth}
          error={getError(errors, 'dateOfBirth')}
          hasError={hasError(errors, 'dateOfBirth')}
          helperText={getError(errors, 'dateOfBirth')}
          placeholder={strings.mainBookOfCremated.form.dateOfBirth}
          name='dateOfBirth'
          onChange={onChange}
          date={data.dateOfBirth ? new Date(data.dateOfBirth) : data.dateOfBirth}
          isClearable={true}
          dateFormat='dd/MM/yyyy'
          disabled={isDisabled}
        />

      }



      {((data.municipalityOfBirth && flag == "edit") || (flag == "add") || data.municipalityOfBirth && (flag == "view")) &&
        <Autocomplete
          id={"municipalityOfBirth"}
          name={"municipalityOfBirth"}
          options={municipalities}
          getOptionLabel={option => `${option.city} ${option.zip}`}
          onChange={onAutocompleteChange}
          renderInput={params => (
            <TextField
              {...params}
              variant="standard"
              label={strings.mainBookOfCremated.form.municipalityOfBirth}
              margin="normal"
              fullWidth
              name={"municipalityOfBirth"}
              onChange={handleTextInputChange}
              InputLabelProps={{
                shrink: true,
              }}
            />
          )}
          disabled={isDisabled}
          value={data.municipalityOfBirth}
        />
      }
      {((!data.municipalityOfBirth && flag == "edit") || (!data.municipalityOfBirth && (flag == "view"))) &&
        <Autocomplete
          id={"municipalityOfBirth"}
          name={"municipalityOfBirth"}
          options={municipalities}
          getOptionLabel={option => `${option.city} ${option.zip}`}
          onChange={onAutocompleteChange}
          renderInput={params => (
            <TextField
              {...params}
              variant="standard"
              label={strings.mainBookOfCremated.form.municipalityOfBirth}
              margin="normal"
              fullWidth
              name={"municipalityOfBirth"}
              onChange={handleTextInputChange}
              InputLabelProps={{
                shrink: true,
              }}
            />
          )}
          disabled={isDisabled}
          value={data.municipalityOfBirth}
        />
      }
      {(data.dateTimeOfDeathString != undefined && data.dateTimeOfDeathString != null && data.dateTimeOfDeathString != "") &&
        <TextField
          label={strings.mainBookOfBuried.form.dateTimeOfDeathString}
          fullWidth
          name='dateTimeOfDeathString'
          onChange={handleTextInputChange}
          margin="normal"
          value={data.dateTimeOfDeathString}
          InputLabelProps={{
            shrink: true,
          }}
          disabled={true}
        />
      }
      <DatePickerControl
        label={strings.mainBookOfCremated.form.dateTimeOfDeath}
        error={getError(errors, 'dateTimeOfDeath')}
        hasError={hasError(errors, 'dateTimeOfDeath')}
        helperText={getError(errors, 'dateTimeOfDeath')}
        placeholder={strings.mainBookOfCremated.form.dateTimeOfDeath}
        name='dateTimeOfDeath'
        onChange={onChange}
        date={data.dateTimeOfDeath ? new Date(data.dateTimeOfDeath) : data.dateTimeOfDeath}
        isClearable={true}
        dateFormat='dd/MM/yyyy HH:mm'
        showTimeSelect={true}
        disabled={isDisabled}
      />
      {((data.causeOfDeath && flag == "edit") || (flag == "add") || (data.causeOfDeath && flag == "view")) &&
        <Autocomplete
          id={"causeOfDeath"}
          name={"causeOfDeath"}
          options={causesOfDeath}
          getOptionLabel={option => option.name}
          onChange={onAutocompleteChange}
          renderInput={params => (
            <TextField
              {...params}
              variant="standard"
              label={strings.mainBookOfCremated.form.causeOfDeath}
              margin="normal"
              fullWidth
              name={"causeOfDeath"}
              onChange={handleTextInputChange}
              InputLabelProps={{
                shrink: true,
              }}
            />
          )}
          disabled={isDisabled}
          value={data.causeOfDeath}
        />
      }
      {((!data.causeOfDeath && flag == "edit") || (!data.causeOfDeath && flag == "view")) &&
        <Autocomplete
          id={"causeOfDeath"}
          name={"causeOfDeath"}
          options={causesOfDeath}
          getOptionLabel={option => option.name}
          onChange={onAutocompleteChange}
          renderInput={params => (
            <TextField
              {...params}
              variant="standard"
              label={strings.mainBookOfCremated.form.causeOfDeath}
              margin="normal"
              fullWidth
              name={"causeOfDeath"}
              onChange={handleTextInputChange}
              InputLabelProps={{
                shrink: true,
              }}
            />
          )}
          disabled={isDisabled}
          value={data.causeOfDeath}
        />
      }
      {((data.doctor && flag == "edit") || (flag == "add") || (data.doctor && flag == "view")) &&
        <Autocomplete
          id={"doctor"}
          name={"doctor"}
          options={doctors}
          getOptionLabel={option => option.name}
          onChange={onAutocompleteChange}
          renderInput={params => (
            <TextField
              {...params}
              variant="standard"
              label={strings.mainBookOfCremated.form.doctor}
              margin="normal"
              fullWidth
              name={"doctor"}
              onChange={handleTextInputChange}
              InputLabelProps={{
                shrink: true,
              }}
            />
          )}
          disabled={isDisabled}
          value={data.doctor}
        />
      }
      {((!data.doctor && flag == "edit") || (!data.doctor && flag == "view")) &&
        <Autocomplete
          id={"doctor"}
          name={"doctor"}
          options={doctors}
          getOptionLabel={option => option.name}
          onChange={onAutocompleteChange}
          renderInput={params => (
            <TextField
              {...params}
              variant="standard"
              label={strings.mainBookOfCremated.form.doctor}
              margin="normal"
              fullWidth
              name={"doctor"}
              onChange={handleTextInputChange}
              InputLabelProps={{
                shrink: true,
              }}
            />
          )}
          disabled={isDisabled}
          value={data.doctor}
        />
      }
      <TextField
        label={strings.mainBookOfCremated.form.registryBookOfDeath}
        error={hasError(errors, 'registryBookOfDeath')}
        helperText={getError(errors, 'registryBookOfDeath')}
        fullWidth
        name='registryBookOfDeath'
        onChange={onChange}
        margin="normal"
        defaultValue={data.registryBookOfDeath}
        value={data.registryBookOfDeath}
        InputLabelProps={{
          shrink: true,
        }}
        disabled={isDisabled}
      />
      {(transporters && ((data.transporter && flag == "edit") || (flag == "add") || (data.transporter && flag == "view"))) &&
        <Autocomplete
          id={"transporter"}
          name={"transporter"}
          options={transporters}
          getOptionLabel={option => option.name}
          onChange={onAutocompleteChange}
          renderInput={params => (
            <TextField
              {...params}
              variant="standard"
              label={strings.mainBookOfCremated.form.transporter}
              margin="normal"
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
            />
          )}
          disabled={isDisabled}
          value={data.transporter}
        />
      }
      {((!data.transporter && flag == "edit") || (!data.transporter && flag == "view")) &&
        <Autocomplete
          id={"transporter"}
          name={"transporter"}
          options={transporters}
          getOptionLabel={option => option.name}
          onChange={onAutocompleteChange}
          renderInput={params => (
            <TextField
              {...params}
              variant="standard"
              label={strings.mainBookOfCremated.form.transporter}
              margin="normal"
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
            />
          )}
          disabled={isDisabled}
          value={data.transporter}
        />
      }
      <TextField
        label={strings.mainBookOfCremated.form.weigth}
        error={hasError(errors, 'weight')}
        helperText={getError(errors, 'weight')}
        fullWidth
        name='weight'
        onChange={onChange}
        margin="normal"
        defaultValue={data.weight}
        value={data.weight}
        InputLabelProps={{
          shrink: true,
        }}
        disabled={isDisabled}
      />
      <TextField
        label={strings.mainBookOfCremated.form.height}
        error={hasError(errors, 'height')}
        helperText={getError(errors, 'height')}
        fullWidth
        name='height'
        onChange={onChange}
        margin="normal"
        defaultValue={data.height}
        value={data.height}
        InputLabelProps={{
          shrink: true,
        }}
        disabled={isDisabled}
      />
      {((data.famousCitizen && flag == "edit") || (flag == "add") || (data.famousCitizen && flag == "view")) &&
        <Autocomplete
          id={"famousCitizen"}
          name={"famousCitizen"}
          options={famousCitizens}
          getOptionLabel={option => option.description}
          onChange={onAutocompleteChange}
          renderInput={params => (
            <TextField
              {...params}
              variant="standard"
              label={strings.mainBookOfCremated.form.famousCitizen}
              margin="normal"
              fullWidth
              name={"famousCitizen"}
              onChange={handleTextInputChange}
              InputLabelProps={{
                shrink: true,
              }}
            />
          )}
          disabled={isDisabled}
          value={data.famousCitizen}
        />
      }
      {((!data.famousCitizen && flag == "edit") || (!data.famousCitizen && flag == "view")) &&
        <Autocomplete
          id={"famousCitizen"}
          name={"famousCitizen"}
          options={famousCitizens}
          getOptionLabel={option => option.description}
          onChange={onAutocompleteChange}
          renderInput={params => (
            <TextField
              {...params}
              variant="standard"
              label={strings.mainBookOfCremated.form.famousCitizen}
              margin="normal"
              fullWidth
              name={"famousCitizen"}
              onChange={handleTextInputChange}
              InputLabelProps={{
                shrink: true,
              }}
            />
          )}
          disabled={isDisabled}
          value={data.famousCitizen}
        />
      }
      <TextField
        multiline={true}
        // rowsMax={5}
        label={strings.mainBookOfCremated.form.note}
        error={hasError(errors, 'note')}
        helperText={getError(errors, 'note')}
        fullWidth
        name='note'
        onChange={onChange}
        margin="normal"
        defaultValue={data.note}
        value={data.note}
        InputLabelProps={{
          shrink: true,
        }}
        disabled={isDisabled}
      />
      {
        !isDisabled &&
        <div className='submit-container'>
          <Button variant="contained" color="primary" onClick={onSubmit}>
            {strings.mainBookOfBuried.form.ok}
          </Button>
          <Button variant="contained" color="secondary" onClick={onCancel}>
            {strings.mainBookOfBuried.form.cancel}
          </Button>
        </div>
      }
    </form>
  )
};

export default DeceasedMainBookOfCrematedForm;